import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fundingContextQuery } from './context-query.js';
import { resolveDeviceMethods } from './device-methods.js';
import { discoverFundingCheckout } from './discover-checkout.js';
export function useFundingDiscovery(options) {
  const $ = _c(26);
  const {
    client,
    currency,
    surface,
    deviceMethods,
    manifest
  } = options;
  const cache = useQueryClient();
  const t0 = client.cacheKey;
  const t1 = options.sessionProofId;
  const t2 = options.resumeOperationId ?? null;
  const t3 = options.directPurchase?.binding.caip19 ?? null;
  const t4 = options.directPurchaseEnabled === true;
  const t5 = options.authenticationRequested ?? false;
  let t6;
  if ($[0] !== deviceMethods) {
    t6 = resolveDeviceMethods(deviceMethods, "sandbox");
    $[0] = deviceMethods;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== deviceMethods) {
    t7 = resolveDeviceMethods(deviceMethods, "production");
    $[2] = deviceMethods;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== t6 || $[5] !== t7) {
    t8 = {
      sandbox: t6,
      production: t7
    };
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== client.cacheKey || $[8] !== currency || $[9] !== manifest || $[10] !== options.sessionProofId || $[11] !== surface || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t8) {
    t9 = ["onramp", t0, "discovery", t1, t2, t3, t4, t5, currency, surface, t8, manifest];
    $[7] = client.cacheKey;
    $[8] = currency;
    $[9] = manifest;
    $[10] = options.sessionProofId;
    $[11] = surface;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      persist: false
    };
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== cache || $[20] !== client || $[21] !== options) {
    t11 = async t12 => {
      const {
        signal
      } = t12;
      const context = await cache.fetchQuery(fundingContextQuery(client));
      return discoverFundingCheckout(options, signal, context);
    };
    $[19] = cache;
    $[20] = client;
    $[21] = options;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t9) {
    t12 = {
      queryKey: t9,
      gcTime: 0,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      meta: t10,
      queryFn: t11
    };
    $[23] = t11;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const discovery = useQuery(t12);
  return discovery;
}